import React from "react";
import { NavLink } from "react-router-dom";
import StaffProfileCard from "../../Staff/partials/StaffProfileCard";
import TimeAgo from "react-timeago";
import CountDownNow from "react-countdown-now";

const RotasList = ({ rotas }) => {
    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th className="text-center">SN</th>
                    <th>Period </th>
                    <th>Time </th>
                    <th>Created By</th>
                    <th className="center"> Staff On Duty </th>
                    <th className="center">View</th>
                </tr>
            </thead>
            <tbody>
                {rotas.map((item, index) => {
                    return (
                        <tr key={index}>
                            <td className="text-center">
                                <span>{index + 1}</span>
                            </td>

                            <td className="view-message">
                                <strong className="text-pink">{item.period.name}</strong>
                                <br />
                                <strong>
                                    {Intl.DateTimeFormat("en-GB", {
                                        month: "short",
                                        year: "numeric",
                                        weekday: "long",
                                        day: "numeric"
                                    }).format(new Date(item.date))}
                                </strong>
                                <p>
                                    <TimeAgo date={item.date} />
                                </p>
                            </td>
                            <td>
                                <strong>
                                    {Intl.DateTimeFormat("en-GB", {
                                        hour12: false,
                                        hour: "numeric",
                                        minute: "numeric",
                                        second: "numeric"
                                    }).format(new Date(item.date))}
                                </strong>
                                <strong> - </strong>
                                <strong>
                                    {Intl.DateTimeFormat("en-GB", {
                                        hour12: false,
                                        hour: "numeric",
                                        minute: "numeric",
                                        second: "numeric"
                                    }).format(new Date(item.end_date))}
                                </strong>
                                <p className="text-danger">
                                    <CountDownNow date={new Date(item.end_date)} />
                                </p>
                            </td>
                            <td className="view-message">
                                <StaffProfileCard item={item.author} />
                            </td>
                            <td className=" center view-message">
                                <span>{item.assignee.length}</span>
                            </td>
                            <td className="view-message text-center">
                                {
                                    <NavLink
                                        className="btn btn-tbl-edit btn-xs"
                                        to={{
                                            pathname: `/home/rota/viewrota`,
                                            state: { id: item.id, item },
                                            search: `?ref=${item.id}`
                                        }}
                                    >
                                        <i className="fa fa-eye"></i>
                                    </NavLink>
                                }
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default RotasList;
